import { FC } from 'react'
import { IManualSuscriptionCollectorAccount } from '../../../../common/interfaces'

interface IProps {
  collectorAccounts: IManualSuscriptionCollectorAccount[]
  value: number | ''
  onChange: (collectorAccountId: number | '') => void
  loading?: boolean
}

export const BankSelect: FC<IProps> = ({ collectorAccounts, value, onChange, loading }) => (
  <div className='col-lg-6 mb-7'>
    <label htmlFor='bank' className='text-muted fs-6 mb-2 d-flex align-items-center gap-2'>
      Banco
      {loading && <span className='spinner-border spinner-border-sm text-primary' role='status' />}
    </label>
    <select
      id='bank'
      className='selectForm contract-select-toggle'
      value={value}
      disabled={loading}
      onChange={(e) => onChange(e.target.value === '' ? '' : Number(e.target.value))}
    >
      <option value=''>Seleccione</option>
      {collectorAccounts.map((account) => (
        <option key={account.id} value={account.id}>
          {account.bank?.description || account.title}
        </option>
      ))}
    </select>
  </div>
)
